'use client'

import { cn } from "@/lib/utils";
import { Stall } from "@/static-stores/stallStore";
import { TrendingUp } from "lucide-react";
import { SectionTitle } from "../SectionTitle";
import { Button } from "../ui/Button";
import { StallCard } from "./StallCard";

interface IStallGrid {
  variant: 'white' | 'gray',
  title: string,
  stalls: Stall[]
}

export function StallGrid({ title, variant, stalls }: IStallGrid) {
  return (
    <section className={
      cn("py-16 px-6 dark:bg-gray-900",
        variant == 'white' ? 
        'bg-white ' :
        'bg-gray-50 '
      )
    }>
      <div className="mx-auto">
        <div className="flex">
          <div className="flex flex-1/2">
            <SectionTitle title={title} />
          </div>
          <div className="flex flex-1/2 items-center justify-between mb-8">
            <SectionTitle title="" />
            <Button variant="outline">
              <TrendingUp className="mr-2 h-4 w-4" />
              View All
            </Button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {stalls.map((stall) => (
           <StallCard key={stall.id} stall={stall} />
          ))}
        </div>
      </div>
    </section>
  )
}
